














































































































































































import Vue from 'vue';

import {
  upload,
  update,
  uploadUnsplashImage,
  uploadCanvaImageUrl,
  uploadPublicUrlImage,
  urlToFile,
  imageSize,
  uploadVimeoThumbnail,
  clearVimeoThumbnail,
  uploadLocal,
  updateLocal,
  localEmbedFileUrl,
  localUploadUnsplashImage,
} from '@/web/services/upload';
import mediaApi from '@/core/api/modules/media-libraries';
import HMUnsplashImageSelectModal from '@/web/components/common/HMUnsplashImageSelectModal.vue';
import HMEmbedImageModal from '@/web/components/common/HMEmbedImageModal.vue';
import { getCanvaButtonApi } from '@/web/services/canva';
import { getConfig } from '@/web/utils/configuration';
import CropImageFormModal from '@/web/components/media-library/CropImageFormModal.vue';
import FocalPointPickerFormModal from '@/web/components/media-library/FocalPointPickerFormModal.vue';
import { errorToMessage } from '@/core/utils/errors';
import HMDialog from '@/web/components/common/HMDialog.vue';

enum photoType {
  cover = 'cover',
  contain = 'contain',
  profile = 'profile',
}

export default Vue.extend({
  name: 'HMImageUpload',
  props: {
    value: {
      type: Object,
      default: null,
    },
    accept: {
      type: String,
      default: 'image/*',
    },
    inputName: {
      type: String,
      default: 'upload-file',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    imageDescription: {
      type: String,
      default: '',
    },
    photoType: {
      type: String as () => photoType,
      default: 'cover',
    },
    canvaDesignType: {
      type: String,
      default: 'BlogBanner',
    },
    canvaWidth: {
      type: Number,
      default: 1920,
    },
    canvaHeight: {
      type: Number,
      default: 1080,
    },
    updateThumbnail: {
      type: Boolean,
      default: false,
    },
    updateLocal: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'normal',
    },
    cropper: {
      type: Boolean,
      default: true,
    },
    round: {
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: String,
      default: '16by9',
    },
    uploadAspectRatio: {
      type: String,
      default: undefined,
    },
    thumbWidth: {
      type: Number,
      default: 0,
    },
    thumbHeight: {
      type: Number,
      default: 0,
    },
    embedImageEnabled: {
      type: Boolean,
      default: true,
    },
    unsplashEnabled: {
      type: Boolean,
      default: true,
    },
    canvaEnabled: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: Number,
      default: undefined,
    },
    focalPointPicker: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: null,
      error: null,
      isUploading: false,
      showDropdown: false,
      isDragging: false,
      reader: new FileReader(),
    };
  },
  computed: {
    status() {
      if (this.isDragging) {
        return 'dragging';
      } else if (this.isUploading) {
        return 'uploading';
      } else if (this.value && !this.updateThumbnail) {
        return 'uploaded';
      } else if (this.updateThumbnail && this.src) {
        return 'uploaded';
      } else {
        return 'add';
      }
    },
    src() {
      if (this.updateThumbnail && this.value) {
        const { embedded_thumbnail_url, thumbnail } = this.value;
        return thumbnail || embedded_thumbnail_url;
      } else {
        return this.value?.storage_url ?? this.value?.embedded_image_url;
      }
    },
    api() {
      if (this.updateThumbnail) {
        const onVimeoThumbnailFailed = this.onVimeoThumbnailFailed;
        const media = this.value;
        const mediaId = media?.id;
        const vimeoVideoId = media?.video_url?.split('/').pop();

        return {
          async upload(inputFile) {
            if (media.file_type === 'vimeo') {
              try {
                return await uploadVimeoThumbnail(
                  mediaId,
                  vimeoVideoId,
                  inputFile
                );
              } catch (error) {
                onVimeoThumbnailFailed(error);
                return await mediaApi.updateMediaFile(mediaId, {
                  custom_thumbnail: inputFile,
                });
              }
            } else {
              return await mediaApi.updateMediaFile(mediaId, {
                custom_thumbnail: inputFile,
              });
            }
          },
          async update(media, data) {
            return await update(media, data);
          },
          async uploadUnsplashImage(unsplashImage) {
            if (media.file_type === 'vimeo') {
              const file = await urlToFile(unsplashImage?.urls?.regular);
              try {
                return await uploadVimeoThumbnail(mediaId, vimeoVideoId, file);
              } catch (error) {
                onVimeoThumbnailFailed(error);
              }
            }

            const thumbnailUrl = unsplashImage?.urls?.regular;
            return await mediaApi.updateMediaFile(mediaId, {
              embedded_thumbnail_url: thumbnailUrl,
            });
          },
          async uploadCanvaImageUrl(url) {
            const file = await urlToFile(url);

            if (media.file_type === 'vimeo') {
              try {
                return await uploadVimeoThumbnail(mediaId, vimeoVideoId, file);
              } catch (error) {
                onVimeoThumbnailFailed(error);
              }
            }
            return await mediaApi.updateMediaFile(mediaId, {
              custom_thumbnail: file,
            });
          },
          async uploadPublicUrlImage(_, url) {
            if (media.file_type === 'vimeo') {
              const file = await urlToFile(url);
              try {
                return await uploadVimeoThumbnail(mediaId, vimeoVideoId, file);
              } catch (error) {
                onVimeoThumbnailFailed(error);
              }
            }

            return await mediaApi.updateMediaFile(mediaId, {
              embedded_thumbnail_url: url,
            });
          },
          async remove() {
            if (media.file_type === 'vimeo') {
              try {
                return await clearVimeoThumbnail(mediaId, vimeoVideoId);
              } catch (error) {
                onVimeoThumbnailFailed(error);
                return await mediaApi.clearFileThumbnails(mediaId);
              }
            } else {
              return await mediaApi.clearFileThumbnails(mediaId);
            }
          },
        };
      } else if (this.updateLocal) {
        return {
          upload: uploadLocal,
          update: updateLocal,
          uploadUnsplashImage: localUploadUnsplashImage,
          uploadCanvaImageUrl: localEmbedFileUrl,
          uploadPublicUrlImage: (_, url) => localEmbedFileUrl(url),
          remove: () => null,
        };
      } else {
        return {
          upload,
          update,
          uploadUnsplashImage,
          uploadCanvaImageUrl,
          uploadPublicUrlImage,
          remove: () => null,
        };
      }
    },
    getUniqueInputName() {
      return `${this.inputName}-${Math.floor(Math.random() * 100)}`;
    },
    imgStyle() {
      const { focal_point_x, focal_point_y } = this.value;
      return {
        objectPosition: `${focal_point_x}% ${focal_point_y}%`,
      };
    },
  },
  methods: {
    showCropImageOptionModal(confirmFn, discardFn, onClose) {
      if (!this.cropper) {
        discardFn();
        return;
      }
      const title = this.$t('GENERAL.TITLE.CROP_IMAGE');
      const subtitle = this.$t('GENERAL.TEXT.CROP_THIS_IMAGE');
      const text = this.$t('GENERAL.TEXT.CROP_THIS_IMAGE_DESCR');
      const discardButton = this.$t('GENERAL.BUTTON.SKIP');
      const confirmButton = this.$t('GENERAL.BUTTON.CROP');
      const confirm = () => {
        confirmFn();
      };
      const discard = () => {
        discardFn();
      };

      this.$modal.show(HMDialog, {
        title,
        subtitle,
        text,
        confirmButton,
        discardButton,
        confirm,
        discard,
        onClose,
      });
    },
    openFocalPointPickerModal(file) {
      this.$modal.show(
        FocalPointPickerFormModal,
        {
          file,
          updateThumbnail: this.updateThumbnail,
          confirm: this.onFocalPointPickerConfirm,
        },
        {
          clickToClose: false,
          classes: ['vm--inline-modal'],
        }
      );
    },
    openCropImageModal(file) {
      this.$modal.show(
        CropImageFormModal,
        {
          round: this.round,
          canvaWidth: this.canvaWidth,
          canvaHeight: this.canvaHeight,
          file,
          confirm: this.onCropConfirm,
          updateThumbnail: this.updateThumbnail,
        },
        {
          clickToClose: false,
          classes: ['vm--inline-modal'],
        }
      );
    },
    async onCropConfirm(croppedFile) {
      const file = await this.loadFile(croppedFile, false);
      this.updateFile(file);
    },
    async onFocalPointPickerConfirm(file, data) {
      const value = await this.api.update(file, data);
      this.updateFile(value);
    },
    async loadFile(inputFile) {
      if (!inputFile) return;
      this.isUploading = true;
      const file = await this.api.upload(
        inputFile,
        undefined,
        undefined,
        this.thumbWidth,
        this.thumbHeight
      );
      this.isUploading = false;
      return file;
    },
    async prepareFileForCropping(inputFile) {},
    async onFile(inputFile) {
      if (!inputFile) return;

      if (this.uploadAspectRatio || this.minWidht) {
        const [
          aspectRatioWidth,
          aspectRatioHeight,
        ] = this.uploadAspectRatio.split(':').map(n => parseInt(n));
        const { width, height } = await imageSize(inputFile);

        if (
          this.uploadAspectRatio &&
          aspectRatioWidth * height !== aspectRatioHeight * width
        ) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Invalid image dimensions',
            text: `Incorrect image aspect ratio. Required width to height ratio is ${this.uploadAspectRatio}`,
          });
          return;
        }

        if (this.minWidth && width < this.minWidth) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Invalid image dimensions',
            text: 'Image size is not correct.',
          });
          return;
        }
      }

      if (!this.isValidFile(inputFile)) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Invalid file',
          text: 'This file extention is not supported',
        });
        return;
      }

      this.isUploading = true;
      this.showCropImageOptionModal(
        async () => {
          this.reader.readAsDataURL(inputFile);
          this.reader.onloadend = evt => {
            if (evt.target.readyState == 2) {
              const file = {
                storage_url: evt.target.result,
                embedded_thumbnail_url: evt.target.result,
              };
              this.openCropImageModal(file);
              this.isUploading = false;
              return file;
            }
          };
          this.reader.onabort = evt => {
            this.isUploading = false;
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'Error loading file',
              text: this.reader.error,
              duration: -1,
            });
          };
          this.reader.onerror = evt => {
            this.isUploading = false;
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'Error loading file',
              text: this.reader.error,
              duration: -1,
            });
          };
        },
        async () => {
          const file = await this.api.upload(
            inputFile,
            undefined,
            undefined,
            this.thumbWidth,
            this.thumbHeight
          );
          this.updateFile(file);
          this.isUploading = false;
        },
        () => {
          this.isUploading = false;
        }
      );
    },
    async onChange(e) {
      const file = e.target.files[0];
      this.$refs.inputFile.value = null;
      this.onFile(file);
    },
    drop: function (event) {
      event.stopPropagation();
      event.preventDefault();
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      this.onFile(file);
    },
    updateFile(file) {
      this.$emit('input', file);
    },
    onVimeoThumbnailFailed(error) {
      // The callers still save the thumbnail to our DB so the library shows it,
      // but the Vimeo player poster is unchanged. Don't let that go unnoticed.
      console.error('Vimeo thumbnail update failed', error);
      // @ts-ignore
      this.$rollbar?.error('Vimeo thumbnail update failed', error, {
        file_id: this.value?.id,
        video_url: this.value?.video_url,
      });
      this.$notify({
        group: 'app',
        type: 'error',
        title: 'Video player thumbnail not updated',
        text:
          'Your library was updated, but Vimeo did not accept the change, so viewers may still see the old image before pressing play. Please try again later.',
        duration: -1,
      });
    },
    dragging() {
      this.isDragging = true;
    },
    draggingStop() {
      this.isDragging = false;
    },
    async remove() {
      this.isUploading = true;
      const file = await this.api.remove();
      this.$emit('input', file);
      this.isUploading = false;
    },
    openUnsplashModal() {
      this.$modal.show(
        HMUnsplashImageSelectModal,
        {
          onSelect: this.onSelectUnsplashImage,
        },
        {
          classes: ['vm--inline-modal'],
        }
      );
    },
    async onSelectUnsplashImage(selectedUnsplashImage) {
      this.isUploading = true;
      const file = await this.api.uploadUnsplashImage(selectedUnsplashImage);
      this.showCropImageOptionModal(
        () => {
          this.openCropImageModal(file);
        },
        () => {
          this.updateFile(file);
        },
        () => {
          this.updateFile(file);
        }
      );
      this.isUploading = false;
    },
    openCanva() {
      let dimensions = {};
      if (this.canvaWidth && this.canvaHeight) {
        dimensions = {
          width: this.canvaWidth,
          height: this.canvaHeight,
        };
      }

      getCanvaButtonApi().createDesign({
        design: {
          type: this.canvaDesignType,
          dimensions: dimensions,
        },
        editor: {
          publishLabel: this.$t('GENERAL.LABEL.CANVA_SAVE_LABEL', {
            applicationName: getConfig().applicationName,
          }),
        },
        onDesignOpen: () => {
          // Triggered when editor finishes loading and opens a new design.
          // You can save designId for future use.
          console.log('Canva designer opened');
        },
        onDesignPublish: ({ exportUrl }) => {
          // Triggered when design is published to an image.
          // Save the image to your server as the exportUrl will expire shortly.
          console.log('Canva design published. Image url=', exportUrl);
          this.uploadCanvaImageUrl(exportUrl);
        },
        onDesignClose: () => {
          // Triggered when editor is closed.
          console.log('Canva designer closed');
        },
      });
    },
    async uploadCanvaImageUrl(imageUrl) {
      this.isUploading = true;
      const file = await this.api.uploadCanvaImageUrl(imageUrl);
      this.showCropImageOptionModal(
        () => {
          this.openCropImageModal(file);
        },
        () => {
          this.updateFile(file);
        },
        () => {
          this.updateFile(file);
        }
      );
      this.isUploading = false;
    },
    openEmbedImageModal() {
      this.$modal.show(
        HMEmbedImageModal,
        {},
        {},
        {
          selectImageUrl: this.embedImage,
        }
      );
    },
    async embedImage(imageUrl) {
      this.isUploading = true;
      const file = await this.api.uploadPublicUrlImage(
        null,
        imageUrl,
        imageUrl
      );
      this.updateFile(file);
      this.isUploading = false;
    },
    isValidFile(inputFile) {
      if (this.accept === 'image/*') return true;
      if (this.accept.includes(inputFile.type)) return true;
      return false;
    },
  },
});
